module.exports = __webpack_public_path__ + "static/media/img_success.463eb086.png";